const Hero = () => {
  return (
    <section className="bg-gradient-to-br from-gray-50 to-gray-100 py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h1 className="text-4xl md:text-6xl font-bold text-gray-900 mb-6">
            Study in
            <span className="text-cyan-500 block">South Korea</span>
          </h1>
          <p className="text-xl text-gray-600 mb-8 max-w-3xl mx-auto">
            Discover and apply to top universities in South Korea. We simplify
            the admission process, connecting ambitious students with
            prestigious institutions in South Korea.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              className="bg-gradient-to-r from-cyan-500 to-blue-500 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:from-cyan-600 hover:to-blue-600 transition-all duration-200"
              onClick={() => {
                window.location.href = "/universities";
              }}
            >
              Explore Korean Universities
            </button>
            <button
              className="border-2 border-orange-400 text-orange-500 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-orange-400 hover:text-white transition-colors duration-200"
              onClick={() => {
                window.location.href = "/about";
              }}
            >
              Learn More About Korea
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
